/* eslint-disable */
import React from "react";
import PropTypes from "prop-types";
import TreeNode from "../../../../models/TreeNode";
import Filter from "../../../../models/Filter";
import CheckboxFilter from "./FilterTypes/CheckboxFilter";

function CheckboxCategory({ handleChange, node }) {
  const sumFn = (a, i) => (i === null ? null : a + i);
  const children = node.getDescendants();
  const subFilters = children.filter((x) => x.totalCount || x.isVisible);
  const sum = subFilters.map((x) => x.value).reduce(sumFn, 0);
  const disableNum = subFilters.find((x) => x.disableCategoryNum);
  const totalCount = disableNum
    ? null
    : subFilters.map((x) => x.totalCount).reduce(sumFn, 0);
  const value = sum / subFilters.length;
  const filter = new Filter({ label: node.id, value, totalCount });

  function handleSubfilters({ value: val }) {
    const ids = children.map((x) => x?.id).filter(Boolean);
    handleChange({ ids, value: val });
  }

  return (
    <div className="tw-flex tw-items-center">
      <div className="tw-flex-grow">
        <CheckboxFilter
          handleChange={handleSubfilters}
          handleHighlight={() => {}}
          filter={filter}
        />
      </div>
      {totalCount !== null ? (
        <span
          data-tooltip="total amount of items available in the graph"
          data-tooltip-class="genome-browser-small-tooltip"
          className="tw-opacity-70 tw-px-2 tw-text-2xs"
        >
          {totalCount.toLocaleString()}
        </span>
      ) : null}
    </div>
  );
}

CheckboxCategory.propTypes = {
  handleChange: PropTypes.func.isRequired,
  node: PropTypes.instanceOf(TreeNode).isRequired,
};

CheckboxCategory.defaultProps = {};

export default CheckboxCategory;
